module.exports = __webpack_public_path__ + "media/customizations/anthemmr/back-25a60032ee44d5ba96ca53c0e4bb654d.jpg";